// extracted by mini-css-extract-plugin
export default {"image":"BX-z","loaded":"CX-z"};